module.exports = __webpack_public_path__ + "457add96101ad85c54f41cf40097b054.png";